<template>
<div class="footerContainer">
  <div class="footerBar">
    <div class="footerInnerContainer">
        <div class="linkContainer">{{initialPrefs.projectName}}
        <a href="#">About</a>
        <a href="#">Contact</a>
        <a href="#">Legal</a>
        <a href="#">etc.</a>
        </div>
    </div>
  </div>
  </div>
</template>

<script>
import "../scss/footer.css";

export default {

}
</script>

<style>
#app{
  min-height: 100vh;
  position: relative;
}


</style>